import { useState } from 'react';

import useTranslation from '@Queries/useTranslation';
import YandexSplitPeriods from '@Components/YandexSplitPeriods';
import useOnClickOutside from '@Hooks/useOnClickOutside';
import AdditionalPeriodBlock from './elems/AdditionalPeriodBlock';

import type { PaymentTypeData } from '@Types/Cart';
import type { FC, HTMLAttributes } from 'react';

export type AdditionalPeriodData = {
  icon: 'attention' | 'chevron';
  variant?: PaymentTypeData;
  totalAmount?: number;
  onChevronClick?(): void;
};

type AdditionalPeriodProps = HTMLAttributes<HTMLDivElement> & AdditionalPeriodData;

const AdditionalPeriod: FC<AdditionalPeriodProps> = (props) => {
  const { className, icon, onChevronClick, variant, totalAmount, ...restProps } = props;
  const { t } = useTranslation();
  const [showedTooltip, setShowTooltip] = useState(false);

  const text = t('ui.yandex-split.additional-period.text');
  const period = t('ui.yandex-split.additional-period.period');
  const tooltip = t('ui.yandex-split.additional-period.tooltip');
  const promoText70k = t('ui.yandex-split.additional-period.70krub.text');
  const promoPrice70k = t('ui.yandex-split.additional-period.70krub.price');
  const promoText80k = t('ui.yandex-split.additional-period.80krub.text');
  const promoPrice80k = t('ui.yandex-split.additional-period.80krub.price');
  const promoNote = t('ui.yandex-split.additional-period.note');

  const handleChevronClick = () => onChevronClick();
  const toggleTooltip = () => setShowTooltip((prev) => !prev);
  const hideTooltip = () => setShowTooltip(false);

  const blockRef = useOnClickOutside<HTMLDivElement>(hideTooltip);

  let promo: { text: string; note: string; price: string | number } | null = null;

  if (totalAmount <= 70_000) {
    promo = { text: promoText70k, note: promoNote, price: promoPrice70k };
  } else if (totalAmount <= 80_000) {
    promo = { text: promoText80k, note: promoNote, price: promoPrice80k };
  }

  return variant?.promoTag ? (
    promo && (
      // <PromoBlock
      //   {...restProps}
      //   className={className}
      //   text={promo.text}
      //   note={promo.note}
      //   price={promo.price}
      // />
      // Cделано как заглушка, тк Яндекс не успел. Будет заменено на AdditionalPeriodBlock.
      <YandexSplitPeriods style={{ marginTop: '10px' }} />
    )
  ) : (
    <AdditionalPeriodBlock
      {...restProps}
      className={className}
      text={text}
      period={period}
      tooltip={tooltip}
      icon={icon}
      showedTooltip={showedTooltip}
      onChevronClick={handleChevronClick}
      onToggleTooltip={toggleTooltip}
      blockRef={blockRef}
    />
  );
};

export default AdditionalPeriod;
